// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__-1DOn","notes":"Notes_notes__3faUQ","note":"Notes_note__wWmAy","markdown":"Notes_markdown__2DfB7"};